var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-estadisticas-consultas"}},[_c('Estadisticas',{attrs:{"titulo":"Estadisticas","datosMostrar":_vm.datosMostrar,"mostrarTablaProgramas":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }